import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { logOut, switchEnvBaseUrl } from 'actions/auth';
import { connect } from 'react-redux';
import CN from 'classnames';
import './Header.css';
import { EnvSwitchDropdown } from 'elements';
import { Menu, Dropdown } from 'antd';


function mapState(state) {
  return {
    accessToken: state.auth.accessToken,
    suAccessToken: state.auth.suAccessToken,
    user: state.auth.user,
    admin: state.auth.admin
  };
}

function mapDispatch(dispatch, props) {
  return {
    logOut() {
      logOut(dispatch);
    },
    switchEnvBaseUrl(envBaseUrl) {
      switchEnvBaseUrl(props.history, envBaseUrl);
    }
  };
}

export const ADMIN_ROLES = {
  'MANAGER': 0,
  'SUPERUSER': 10
};


const reloadFunction = (relLinkRedirect) => {
  const type = window.location.href.split('/').pop();
  if (type === relLinkRedirect) {
    window.location.reload();
  }
};

class Header extends Component {
  handleLogOut() {
    this.props.logOut();
    this.props.history.push('/login');
  }

  get psychicAuthenticated() {
    return this.props.accessToken ? this.props.accessToken.length > 0 : false;
  }

  get superuserAuthenticated() {
    return this.props.suAccessToken ?
      (this.props.suAccessToken.length > 0 &&
        (this.props.admin && this.props.admin.role === ADMIN_ROLES.SUPERUSER)
      ) : false;
  }

  get managerAuthenticated() {
    return this.props.suAccessToken ? (this.props.suAccessToken.length > 0) : false;
  }


  render() {
    const { user, admin } = this.props;
    const envBaseUrl = localStorage.getItem('envBaseUrl', null);
    const tfEnd = envBaseUrl === 'https://api.tarotfox.com' || envBaseUrl === 'http://dev.api.mypsychic.com';

    const menu = (
      <Menu>
        { (this.superuserAuthenticated && tfEnd) &&
        <Menu.Item>
          <NavLink exact to="/get-user-reports">Get user reports</NavLink>
        </Menu.Item>
        }
        <Menu.Item>
          <NavLink exact to="/cohortsearch">Cohort search</NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink exact to="/stats">Manager stats</NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink exact to="/stat-c-charts">Conversion stats</NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink exact to="/stat-charts">Managers comparison</NavLink>
        </Menu.Item>
        {/*<Menu.Item>*/}
        {/*  <NavLink exact to="/stat-env-m-charts">Sales data bar</NavLink>*/}
        {/*</Menu.Item>*/}
        <Menu.Item>
          <NavLink exact to="/daily-stats">Sales data</NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink exact to="/psychicbot-stats">Psychic bot data</NavLink>
        </Menu.Item>
      </Menu>
    );

    return (
      <div
        className={ CN('header layout horizontal center pl-20', {
          'su-header': this.superuserAuthenticated,
          'manager-header': this.managerAuthenticated
        }) }
      >
        {
          (this.superuserAuthenticated || this.managerAuthenticated) &&
          <EnvSwitchDropdown
            clickFunction={ this.props.switchEnvBaseUrl }
          />
        }

        <nav className="nav self-stretch layout horizontal">
          { (this.superuserAuthenticated || this.managerAuthenticated) &&
          <NavLink className="layout horizontal center-center" exact to="/psychics">All Psychics</NavLink>
          }
          { this.superuserAuthenticated &&
          <Dropdown overlay={ menu } trigger={ ['click'] } className="layout horizontal center-center">
            <a
              className="layout horizontal center-center"
            >
              Admin Tools
            </a>
          </Dropdown>
          }
          {
            this.psychicAuthenticated &&
            <NavLink
              className="layout horizontal center-center"
              exact to="/p-conversations"
              onClick={ () => reloadFunction('p-conversations') }
            >Paid Conversations</NavLink>
          }
          {
            this.psychicAuthenticated &&
            <NavLink
              className="layout horizontal center-center"
              exact to="/f-conversations"
              onClick={ () => reloadFunction('f-conversations') }
            >Free Conversations</NavLink>
          }
          {
            this.psychicAuthenticated &&
            <NavLink
              className="layout horizontal center-center"
              exact to="/u-conversations"
              onClick={ () => reloadFunction('u-conversations') }
            >Unanswered 24h+ Conversations</NavLink>
          }
          {
            this.psychicAuthenticated &&
            <NavLink
              className="layout horizontal center-center"
              exact to="/e-conversations"
              onClick={ () => reloadFunction('e-conversations') }
            >
              Empty Conversations
            </NavLink>
          }
        </nav>
        <div className="justified-right">
          { (this.psychicAuthenticated || this.superuserAuthenticated || this.managerAuthenticated) &&
          <div>
            <div className="logout-area">
              { this.psychicAuthenticated &&
              <div
                className="user-info">{ admin && `${ admin.username } => ` }{ user.name }, { user.email }, { user.type }</div>
              }
              <button className="logout-btn pointer" onClick={ this.handleLogOut.bind(this) }>Log out</button>
            </div>
          </div>
          }
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapState, mapDispatch)(Header));




// WEBPACK FOOTER //
// ./src/layouts/partials/header/Header.jsx